var Common = {
  currentUser: JSON.parse(localStorage.getItem('userData')),
  isOn: localStorage.getItem('isOn'),
  baseUrl: 'https://sos1.cliniqueadmin.com/',
  baseApiUrl: 'https://sos1.cliniqueadmin.com/api/'
};
export default Common;